import { render, staticRenderFns } from "./travel-policy-detail-info.vue?vue&type=template&id=b97fca8a&scoped=true&"
import script from "./travel-policy-detail-info.vue?vue&type=script&lang=js&"
export * from "./travel-policy-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./travel-policy-detail-info.vue?vue&type=style&index=0&id=b97fca8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97fca8a",
  null
  
)

export default component.exports